import type { Video } from '@/mocks/videos';
import VideoCard from '@/components/feature/VideoCard';

interface VideoGridProps {
  videos: Video[];
  columns?: string;
  emptyTitle?: string;
  emptyText?: string;
}

export default function VideoGrid({
  videos,
  columns = 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
  emptyTitle = '暂时没有找到视频',
  emptyText = '换个关键词或筛选条件试试吧',
}: VideoGridProps) {
  if (videos.length === 0) {
    return (
      <div className="w-full py-16 text-center bg-background-100 border border-background-200 rounded-lg">
        <span className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-200 text-foreground-500 text-3xl">
          <i className="ri-emotion-sad-line"></i>
        </span>
        <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{emptyTitle}</h3>
        <p className="mt-2 text-sm text-foreground-600">{emptyText}</p>
      </div>
    );
  }

  return (
    <div className={`grid ${columns} gap-4 md:gap-5`}>
      {videos.map((v) => (
        <VideoCard key={v.id} video={v} />
      ))}
    </div>
  );
}